<div [class.compact]="compactMode" class="session-timeout-timer">
  <div
    [attr.aria-atomic]="alertLevel === 'critical'"
    [attr.aria-label]="getAriaLabel()"
    [class.critical]="alertLevel === 'critical'"
    [class.warning]="alertLevel === 'warning'"
    class="timer-display"
    aria-live="polite"
    role="timer"
  >
    <span *ngIf="!compactMode" class="timer-label">{{ "Session expires in" | translate }}</span>
    <span class="timer-value">{{ displayTime }}</span>
  </div>

  <div
    *ngIf="showProgressBar"
    [attr.aria-valuemax]="sessionTimeout"
    [attr.aria-valuemin]="0"
    [attr.aria-valuenow]="timeRemaining"
    class="progress-container"
    role="progressbar"
  >
    <div
      [class.critical]="alertLevel === 'critical'"
      [class.warning]="alertLevel === 'warning'"
      [style.width.%]="progressPercentage"
      class="progress-bar"
    ></div>
  </div>
</div>
